/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 1 = CurrentEmployment
 *
 * 2 = PreviousEmployment
 */
export enum ApplicantEmploymentType {
  CurrentEmployment = 1,
  PreviousEmployment = 2,
}
